import { useCollection } from "@/app/collections/store/use-collection"
import { WalletConnectMoleculeReatom } from "@/app/wallet-connect/store.reatom"
import type { CurrencyId } from "@rarible/api-client"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { useSwitchEvmChain } from "../../use-switch-evm-chain"
import { CollectionBidTransactionMoleculeReatom } from "./evm-collection-bid-molecule.reatom"

export function useEvmCollectionBid() {
  const collection = useCollection()
  const { collectionBidActionFactory } = useMolecule(
    CollectionBidTransactionMoleculeReatom,
  )
  const { address } = useMolecule(WalletConnectMoleculeReatom)

  const addressValue = address()

  const collectionBidAction = useMemo(() => {
    return collectionBidActionFactory()
  }, [collectionBidActionFactory])

  const onSuccess = useCallback(
    (params: {
      amount?: number
      price: number
      currency: string
      expirationDate?: Date
    }) => {
      if (!addressValue) {
        throw new Error("Cannot make collection bid for not logged in user")
      }
      collectionBidAction({
        collection,
        amount: params.amount ?? 1,
        currency: params.currency as CurrencyId,
        price: params.price.toString(),
      })
    },
    [collectionBidAction, collection, addressValue],
  )

  const { action, switchInProgress } = useSwitchEvmChain(
    collection.blockchain,
    onSuccess,
  )

  const isPending = collectionBidAction.pending() || switchInProgress

  return {
    mutate: action,
    isPending,
  }
}
